const objectToPieChartData = (obj: any) => {
	const array = Object.keys(obj).map((key) => ({
		name: key,
		value: obj[key]
	}));

	return array;
};

export default objectToPieChartData;
